import { InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { IAction } from '../../action/IAction'
import type { AiCreditTransaction } from './AiCreditTransaction'
import type { AiCreditTransactionTotals } from './AiCreditTransactionTotals'

/**
 * Args for the generic cross-module credit-ledger totals aggregate. The owner scope rides inside
 * `filter` as the neutral wire key `filter.ownerId` (never the QuickScore-domain `schoolId` —
 * `glossary.md`), `typeof`-guarded in `GetCreditLedgerTotals` — it is no longer a top-level arg.
 * `SchoolResolver.schoolLedgerGetTotals` renames its own `filter.schoolId` to `ownerId` before
 * delegating here.
 */
@InputType()
export class GetCreditLedgerTotalsArgs extends QueryArgs<AiCreditTransaction> {}

export interface IGetCreditLedgerTotals extends IAction<AiCreditTransactionTotals, GetCreditLedgerTotalsArgs> {}
